import { v4 as uuid } from 'uuid';
import { AppAdoptionEvents } from "./AppAdoptionEvents"
import { CollaboratorsEvents } from "./CollaboratorsEvents"
import { MainScreenEvents } from "./MainEvents"
import { NovedadesExportEvents } from "./NovedadesExportEvents"
import { PlatformNoticesEvents } from "./PlatformNoticesEvents"
import { RosterEvents } from "./RosterEvents"
import { TwoFactorAuthenticationEvents } from "./TwoFactorAuthenticationEvents"

export type BaseEvent = {
  eventID?: string
  organizationID?: string
  userID?: string
  timestamp: number
  source: 'web'
  metadata?: Record<string, unknown>
}

export type SpecificEvents = (
    MainScreenEvents |
    NovedadesExportEvents |
    RosterEvents |
    CollaboratorsEvents |
    TwoFactorAuthenticationEvents |
    AppAdoptionEvents |
    PlatformNoticesEvents
)

// ----------------------------------------------------------------------------
export type AppEvent = BaseEvent & (
    SpecificEvents
)

/**
 * Factory to build AppEvent with base properties pre-filled
 */
export function createEvent<T extends SpecificEvents>(
    base: Omit<BaseEvent, 'eventID' | 'timestamp' | 'organizationID'> & { eventID?: string; timestamp?: number, organizationID?: string },
    specific: T
): AppEvent {
    return {
        eventID: base.eventID ?? uuid(),
        timestamp: base.timestamp ?? Date.now(),
        organizationID: base.organizationID ?? '',
        ...base,
        ...specific
    }
}
